//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  computed: {
    expertsMobile () {
      return this.$t('science.ourMedicalExperts.experts')
    },
    experts () {
      return this.createGroups(this.$t('science.ourMedicalExperts.experts'), 1)
    }
  },
  methods: {
    nextSlide () {
      this.$refs.carousel.nextSlide()
    },
    prevSlide () {
      this.$refs.carousel.prevSlide()
    },
    slideChanged (slide) {
      this.currentSlide = slide
    },
    createGroups (mainList, numGroups) {
      const elementsPerGroup = Math.ceil(mainList.length / numGroups)
      return new Array(numGroups)
        .fill('')
        .map((el, index) => mainList.slice(index * elementsPerGroup, (index + 1) * elementsPerGroup))
    }
  }
}
